export default "__VITE_ASSET__6b07eb17__"